(function() {
    'use strict';

    angular.module('ecrd.states')
        .controller('FormStatesController', FormStatesController);

    FormStatesController.$inject = [
        'ShareCrfSentry',
        '$exceptionHandler',
        '$window',
        'CrdConfigurationService',
        'Event',
        'ErrorMessages',
        'FormStatesService',
        'gettextCatalog',
        'InetsysMessages',
        'Modal',
        'RecordValidationService',
        'RecordMetadataService',
        'StudyContext',
        'ViewMode',
        'ViewModes',
    ];

    function FormStatesController(
        ShareCrfSentry,
        $exceptionHandler,
        $window,
        CrdConfigurationService,
        Event,
        ErrorMessages,
        FormStatesService,
        gettextCatalog,
        InetsysMessages,
        Modal,
        RecordValidationService,
        RecordMetadataService,
        StudyContext,
        ViewMode,
        ViewModes
    ) {
        var vm = this;
        var _ = $window._;

        // Los estados disponibles, definidos en la aplicación
        vm.availableStates = FormStatesService.getAvailableStates();

        // Si tiene la capacidad de actualizar los flags de estados (poner o quitar), se habilita el botón
        vm.editableStates = {};

        // Si está abierto el panel de acciones sobre estados
        vm.visibleMenu = false;

        // Si está configurado el bloqueo de formularios
        vm.hasLock = FormStatesService.hasLock();

        // Si tiene la capacidad de actualizar el flag de bloqueo (poner o quitar), se habilita el botón
        vm.hasEditableLock = false;

        // Si hay estados disponibles para el formulario definidos en el cuaderno
        vm.isAvailable = false;

        // Si el formulario está bloqueado
        vm.isLocked = false;

        // Los estados editables
        vm.editionInfo = {};

        // Estados habilitados y deshabilitados en el formulario (los datos)
        vm.activeStates = {};
        var auditEnabled = CrdConfigurationService.hasAudit() && StudyContext.canAccessEntityAudit();
        vm.auditableStates = {};
        vm.hasAuditableStates = false;

        // Indexado por ID del estado
        vm.cannotUpdateReason = {};

        // La etiqueta para colocar el texto en posibles mensajes de popup
        var _recordLabel = CrdConfigurationService.getLabelSingular();

        // Suscripción de eventos de validación
        var _eventListeners = [];

        vm.$onInit = function() {
            vm.editableStates = FormStatesService.getEditableStates(vm.formId);
            vm.activeStates = FormStatesService.getEnabledStates(vm.formId, vm.listIndices);
            vm.auditableStates = getAuditableStates();
            vm.hasAuditableStates = Object.keys(vm.auditableStates).length > 0;

            vm.hasEditableLock = FormStatesService.hasEditableLock();
            vm.isLocked = FormStatesService.isLocked(vm.formId, vm.listIndices);

            vm.isAvailable = FormStatesService.hasAnyEditableAction();

            _setEditableStates();
            vm.reloadMetadata();

            _setUpListeners();
        };

        vm.metadata = {};
        vm.showMetadata = false;
        vm.reloadMetadata = function() {
            // Clean previous metadata
            for (var key in vm.metadata) {
                delete vm.metadata[key];
            }

            // Build state keys list
            var availableStates = [].concat(
                FormStatesService.hasLock() ? ['locked'] : [],
                Object.keys(FormStatesService.getAvailableStates())
            );

            // Get metadata
            vm.showMetadata = false;
            for (var index in availableStates) {
                var stateKey = availableStates[index];
                vm.metadata[stateKey] = RecordMetadataService.getFormState(stateKey, vm.formId, vm.listIndices);
                vm.showMetadata = vm.showMetadata || !!vm.metadata[stateKey];
            }
        };

        vm.$onDestroy = function() {
            _tearDownListeners();
        };

        vm.toggleMenu = function() {
            vm.visibleMenu = !vm.visibleMenu;
        };

        vm.toggleLock = function() {
            return FormStatesService.toggleLock(vm.formId, vm.listIndices)
                .then(function(result) {
                    if (result === 'cancel') {
                        return;
                    }

                    vm.isLocked = result;

                    InetsysMessages.success({
                        title: result
                            ? gettextCatalog.getString('Se ha bloqueado el formulario')
                            : gettextCatalog.getString('Se ha desbloqueado el formulario'),
                    });

                    // Al cambiar el bloqueo puede cambiar la accesibilidad del resto de estados
                    _setEditableStates();
                })
                .catch(function(error) {
                    if (error !== Modal.DISMISSED) {
                        InetsysMessages.error({
                            mode: 'modal',
                            title: gettextCatalog.getString('No se ha podido cambiar el bloqueo del formulario'),
                            body: ErrorMessages.get(error),
                        });

                        // Capture exception in Sentry
                        ShareCrfSentry.captureError(error);
                    }

                    return $exceptionHandler(error, 'toggle form lock');
                })
                .finally(function() {
                    vm.visibleMenu = false;
                });
        };

        vm.toggleState = function(stateId) {
            return FormStatesService.toggleState(stateId, vm.formId, vm.listIndices)
                .then(function(result) {
                    if (result === 'cancel') {
                        return;
                    }

                    var reloadFormStateSpan = ShareCrfSentry.startSpan({
                        description: 'Reload Form State',
                    });

                    // Se recarga la información de estados
                    vm.activeStates = FormStatesService.getEnabledStates(vm.formId, vm.listIndices);
                    vm.auditableStates = getAuditableStates();
                    vm.hasAuditableStates = Object.keys(vm.auditableStates).length > 0;

                    ShareCrfSentry.finish(reloadFormStateSpan);

                    var successTitle;

                    if (result) {
                        successTitle = gettextCatalog.getString('Se ha activado el estado {{name}}', {
                            name: vm.availableStates[stateId].name,
                        });
                    } else {
                        successTitle = gettextCatalog.getString('Se ha anulado el estado {{name}}', {
                            name: vm.availableStates[stateId].name,
                        });
                    }

                    // Success message
                    InetsysMessages.success({
                        title: successTitle,
                    });
                })
                .catch(function(error) {
                    if (error !== Modal.DISMISSED) {
                        InetsysMessages.error({
                            mode: 'modal',
                            title: gettextCatalog.getString('No se puede actualizar el estado del formulario'),
                            body: ErrorMessages.get(error),
                        });

                        // Capture exception in Sentry
                        ShareCrfSentry.captureError(error);
                    }

                    return $exceptionHandler(error, 'toggle form state');

                })
                .finally(function() {
                    vm.visibleMenu = false;
                });
        };

        function _setEditableStates() {
            vm.editionInfo = FormStatesService.getEditionInfo(vm.formId, vm.listIndices);

            angular.forEach(vm.editionInfo, function(data, stateId) {
                vm.cannotUpdateReason[stateId] = _translateReason(data.reason);
            });
        }

        function _translateReason(reason) {
            if (reason === 'unavailable') {
                return gettextCatalog.getString('La gestión de estados está deshabilitada para este formulario');
            }

            if (reason === 'validation') {
                return gettextCatalog.getString('Se deben corregir los errores para ejecutar esta acción');
            }

            if (reason === 'global-lock') {
                return gettextCatalog.getString('{{entity}} en estado bloqueado de forma global', {
                    entity: _recordLabel,
                });
            }

            if (reason === 'form-lock') {
                return gettextCatalog.getString('Este formulario está bloqueado');
            }

            if (reason === 'permission') {
                return gettextCatalog.getString('Su perfil de acceso no cuenta con permisos para ejecutar esta acción');
            }

            return reason;
        }

        function _setUpListeners() {
            _eventListeners.push(RecordValidationService.events.on('validateForm', function(eventFormId, eventIndices) {
                if (eventFormId === parseInt(vm.formId, 10) && _.isEqual(vm.listIndices, eventIndices)) {
                    return _setEditableStates();
                }
            }));

            // Cuando se bloquea el registro se dejan de poder actualizar los estados
            _eventListeners.push(Event.on('entityActionEnd', function(event, eventData) {
                if (angular.isArray(eventData) && eventData[0] === 'state' && eventData[1] === 'lock') {
                    _setEditableStates();
                }
            }));

            // De manera general, al recargar los metadatos se actualiza la información
            _eventListeners.push(RecordMetadataService.events.on('load', function() {
                _setEditableStates();
                vm.activeStates = FormStatesService.getEnabledStates(vm.formId, vm.listIndices);
                vm.auditableStates = getAuditableStates();
                vm.hasAuditableStates = Object.keys(vm.auditableStates).length > 0;
                vm.reloadMetadata();
            }));

            if (CrdConfigurationService.hasRevisionStates()) {
                vm.revisionModeEnabled = ViewMode.get() === ViewModes.REVISION;
                _eventListeners.push(Event.on('viewModeChanged', function(event, mode) {
                    vm.revisionModeEnabled = mode === ViewModes.REVISION;
                }));
            }
        }

        function _tearDownListeners() {
            angular.forEach(_eventListeners, function(deregister) {
                deregister();
            });
        }

        vm.viewAuditChanges = function(stateId) {
            return FormStatesService.getAuditChanges(vm.formId, vm.listIndices, stateId)
                .then(function(response) {
                    vm.openActions = false;

                    return Modal.open({
                        template: 'modules/states/components/record-states/modal-audit-changes.html',
                        data: {
                            state: CrdConfigurationService.getStates().getState(stateId),
                            changes: response.data,
                            formId: vm.formId,
                        },
                    }).closePromise;
                })
                .catch(function(error) {
                    if (error !== Modal.DISMISSED) {
                        InetsysMessages.error({
                            mode: 'modal',
                            title: gettextCatalog.getString('No se ha podido obtener audit del estado {{name}}', {
                                name: vm.availableStates[stateId].name,
                            }),
                            body: ErrorMessages.get(error),
                        });

                        // Capture exception in Sentry
                        ShareCrfSentry.captureError(error);
                    }

                    return $exceptionHandler(error, 'view form audit changes');
                });
        };

        function getAuditableStates() {
            if (!auditEnabled) {
                return {};
            }

            return angular.merge(
                FormStatesService.getEnabledStates(vm.formId, vm.listIndices),
                FormStatesService.getDisabledStates(vm.formId, vm.listIndices)
            );
        }
    }
})();
